<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard shape="tab"
                       @on-complete="complete"
                       error-color="#EB5E28"
                       color="#66615B"
                       title="Ajout d'une boutique"
                       subtitle="">
            <tab-content title="Produit"
                         :before-change="validateFirstStep"
                         icon="ti-home">
              <h5 class="text-center">Indiquez le nom, la description et une photo de votre produit.</h5>
               <div class="row">
                 <div class="col-md-10 col-md-offset-1">
                   <div class="form-group">
                     <label class="control-label">
                       Nom
                     </label>
                     <input class="form-control"
                            type="text"
                            name="name"
                            v-validate="modelValidations.name"
                            v-model="model.name"
                            placeholder="Nom de votre produit"
                     />
                     <small class="text-danger" v-show="name.invalid">
                       {{ getError('name') }}
                     </small>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <div class="col-md-10 col-md-offset-1">
                   <div class="form-group">
                     <label class="control-label">
                       Description
                     </label>
                     <textarea
                      class="form-control"
                      rows="3"
                      v-validate="modelValidations.address"
                      v-model="model.description"
                      name="description"
                      placeholder="Description du produit"
                      debounce="2000"></textarea>
                     <small class="text-danger" v-show="description.invalid">
                       {{ getError('description') }}
                     </small>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <div class="col-md-10 col-md-offset-1">
                   <div class="form-group">
                     <label class="control-label">Photo</label>
                     <img style="cursor: pointer;" @click="$refs.input.click()" class="avatar form-control border-white" :src="model.picture ? model.picture.url : 'static/img/default-product.png'" alt="...">
                     <input
                       v-show="false"
                       ref="input"
                       accept="image/*"
                       type="file"
                       @change="fileSelected" />
                       <input
                         v-show="false"
                         type="text"
                         name="picture"
                         v-model="model.picture"
                         v-validate="modelValidations.picture">
                       <small class="text-danger" v-show="picture.invalid" />
                         {{ getError('picture') }}
                       </small>
                   </div>
                 </div>
               </div>
            </tab-content>

            <tab-content title="Inventaire"
                         :before-change="validateSecondStep"
                         icon="ti-settings">
            </tab-content>

            <tab-content title="Preview"
                         icon="ti-eye">
              <Card :company="company" :product="model" />
            </tab-content>

            <tab-content title="Validation"
                         icon="ti-check">
              <h2 class="text-center text-space">Votre produit est prête !
                <br>
                <small>Cliquer sur "<b>Terminer</b>" pour finaliser l'ajout de votre produit.</small>
              </h2>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Retour</button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next">Suivant</button>

            <Uploader slot="finish" ref="uploader" :reference="`/companies/${company.id}/products`" :value="model" @success="displaySuccess" @error="displayError" />
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import {mapFields} from 'vee-validate'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Card from '@/components/Product/Card.vue'
  import Uploader from '@/components/Utils/Uploader'
  import swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        loading: false,
        progress: null,
        file: null,
        model: {
          name: '',
          description: '',
          picture: ''
        },
        modelValidations: {
          name: {
            required: true
          }
        }
      }
    },
    components: {
      FormWizard,
      TabContent,
      Card,
      Uploader
    },
    computed: {
      ...mapFields(['name', 'description', 'picture']),
      ...mapGetters('companies', {
        company: 'mine'
      }),
      ...mapGetters('profiles', {
        profile: 'mine'
      })
    },
    methods: {
      complete () {
        this.$refs.uploader.upload()
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validateFirstStep () {
        return this.$validator.validateAll({
          name: this.model.name,
          description: this.model.description,
          picture: this.model.picture
        })
      },
      validateSecondStep () {
        return this.$validator.validateAll()
      },
      displaySuccess (doc) {
        swal('Terminé !', `Votre produit ${this.model.name} a été ajouté`, 'success')
        .then((value) => {
          this.$router.push({name: 'ProductList'})
        })
      },
      displayError (error) {
        swal('Erreur !', `Le produit n'a pas pu être ajouté : ${error}`, 'error')
      },
      fileSelected (ev) {
        const file = ev.target.files[0]
        if (file) {
          this.model.picture = file
          this.model.picture.url = URL.createObjectURL(file)
        }
      }
    }
  }
</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Company/Product/Add.vue